module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.participantUserId !== undefined) ? _c('breadcrumbs', {
    attrs: {
      "crumbs": [{
        name: (_vm.participantSingularName + " Dashboard"),
        link: 'Dashboard Participant',
        id: _vm.participantUserId
      }, (_vm.participantSingularName + " Details")]
    }
  }) : _c('breadcrumbs', {
    attrs: {
      "crumbs": [(_vm.participantSingularName + " Details")]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 reset-right"
  }, [_c('div', {
    staticClass: "portlet light avatar-sidebar"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('i', {
    staticClass: "icon-globe theme-font hide"
  }), _vm._v(" "), (_vm.participantUserId === undefined) ? _c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("\n                  New " + _vm._s(_vm.participantSingularName.toLowerCase()) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.participantUserId !== undefined && _vm.user !== '') ? _c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("\n                  " + _vm._s(_vm.name) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('avatar', {
    attrs: {
      "username": _vm.name,
      "src": (_vm.$route.params.historyid == null) ? _vm.user.avatar : _vm.avatarHistory,
      "size": 140,
      "rounded": true,
      "color": "#d09f23",
      "backgroundColor": "#eef1f5"
    }
  })], 1), _vm._v(" "), (_vm.participantUserId != undefined) ? _c('div', [_c('a', {
    staticClass: "btn green",
    on: {
      "click": _vm.toggleShow
    }
  }, [_vm._v("Upload Image")]), _vm._v(" "), _c('vue-image-crop-upload', {
    attrs: {
      "field": "img",
      "noRotate": false,
      "width": 300,
      "height": 300,
      "lang-type": "en",
      "img-format": "png"
    },
    on: {
      "crop-success": _vm.cropSuccess
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateAvatar(null)
      }
    }
  }, [_vm._v("Remove")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title tabbable-line"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('i', {
    staticClass: "icon-globe theme-font hide"
  }), _vm._v(" "), (_vm.$route.params.historyid == null) ? _c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v(_vm._s(_vm.participantSingularName) + " details")]) : _c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("Assignment History - " + _vm._s(_vm._f("formatDateModalNoTimeZone")(_vm.formDate)))])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs profile-tabs"
  }, [_vm._l((_vm.forms), function(form, index) {
    return (form.forms[0] != null) ? _c('li', {
      class: {
        active: _vm.query.activeTab === _vm.generateId(form.name) || !_vm.query.activeTab && index == 1,
        disabled: index != 1 && !_vm.participantUserId
      },
      on: {
        "click": function($event) {
          return _vm.clearModifyForms()
        }
      }
    }, [_c('a', {
      attrs: {
        "href": '#' + _vm.generateId(form.name),
        "data-toggle": "tab",
        "aria-expanded": "false"
      }
    }, [_vm._v(_vm._s(form.name))])]) : _vm._e()
  }), _vm._v(" "), (_vm.forms.length != 0 && _vm.logged.access > 2) ? _c('li', {
    class: {
      active: _vm.query.activeTab === 'correspondence',
      disabled: !_vm.participantUserId
    },
    on: {
      "click": function($event) {
        return _vm.clearModifyForms()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#correspondence",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("Correspondence")])]) : _vm._e(), _vm._v(" "), (_vm.$route.params.historyid != null && _vm.logged.access > 2) ? _c('li', {
    class: {
      active: _vm.query.activeTab === 'modifyForms',
      disabled: !_vm.participantUserId
    }
  }, [_c('a', {
    attrs: {
      "href": "#modifyForms",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("Modify Forms")])]) : _vm._e(), _vm._v(" "), (_vm.$route.params.historyid != null && _vm.logged.access > 2) ? _c('li', {
    class: {
      active: _vm.query.activeTab === 'communication-notes',
      disabled: !_vm.participantUserId
    },
    on: {
      "click": function($event) {
        return _vm.clearModifyForms()
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#communication-notes",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("Communication Notes")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content marginTop"
  }, [_vm._l((_vm.forms), function(form, index) {
    return ((index == 1 || _vm.participantUserId) && form.forms[0] != null) ? _c('div', {
      staticClass: "tab-pane",
      class: {
        active: _vm.query.activeTab === _vm.generateId(form.name) || !_vm.query.activeTab && index == 1
      },
      attrs: {
        "id": _vm.generateId(form.name)
      }
    }, [(_vm.showLoading || _vm.showParticipantCloneLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), (!_vm.showParticipantCloneLoading && !_vm.initialReferralDataLoading) ? _c('vue-form-render', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isFormShown(form)),
        expression: "isFormShown(form)"
      }],
      ref: "formRender",
      refInFor: true,
      attrs: {
        "schema": form.forms[0].data,
        "conditions": form.forms[0].conditionals,
        "hideValues": form.forms[0].hide_values ? JSON.parse(form.forms[0].hide_values) : '[]',
        "systemConditions": form.forms[0].system_conditionals,
        "validation-conditions": form.forms[0].extra_validation_rules,
        "calculations": form.forms[0].calculations,
        "values": form.forms[0].values,
        "name": _vm.generateId(form.name),
        "programs": _vm.programs,
        "lockform": _vm.isFormLocked(form),
        "formblock": _vm.formBlock,
        "map": form.forms[0].columns_map,
        "latestDismissedAssignment": _vm.isLatestDismissedAssignment,
        "date-format": _vm.logged.date_format,
        "user-access-level": _vm.logged.access
      }
    }) : _vm._e(), _vm._v(" "), (form.key === 'participants_assignment') ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(_vm.logged.access > 2) ? _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.hasAssignment && !_vm.showForm && _vm.user.assignments && _vm.user.assignments.length !== 0),
        expression: "!hasAssignment && !showForm && user.assignments && user.assignments.length !== 0"
      }],
      staticClass: "btn green",
      staticStyle: {
        "margin-bottom": "20px"
      },
      on: {
        "click": _vm.showAssignmentForm
      }
    }, [_vm._v("Add New Assignment\n                    ")]) : _vm._e()]), _vm._v(" "), (_vm.user.assignments && _vm.user.assignments.length) ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "mt-element-list assignment-elements"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "mt-list-container list-simple"
    }, [_c('ul', _vm._l((_vm.user.assignments), function(record) {
      return _c('li', {
        staticClass: "mt-list-item"
      }, [_vm._m(1, true), _vm._v(" "), _c('div', {
        staticClass: "list-datetime"
      }, [_vm._v(_vm._s(_vm._f("formatDateModalNoTimeZone")(record.programStatusStartDate.date)) + " - " + _vm._s(_vm._f("formatDateModalNoTimeZone")(record.programStatusEndDate ?
        record.programStatusEndDate.date : '')) + "\n                            ")]), _vm._v(" "), _c('div', {
        staticClass: "list-item-content",
        class: (_vm.currentLoading == record.id) ? 'loading' : ''
      }, [_c('h4', {
        class: (record.id == _vm.$route.params.historyid) ? 'active' : ''
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'Participant History',
            params: {
              id: _vm.participantUserId,
              historyid: record.id
            }
          },
          "tag": "a",
          "active-class": "active"
        }
      }, [_vm._v(_vm._s(record.programStatus) + "\n                                  " + _vm._s((record.id == _vm.$route.params.historyid) ?
        '(active)' : '') + "\n                                  "), _c('i', {
        staticClass: "fa fa-spinner fa-pulse fa-fw hide"
      })])], 1)])])
    }), 0)])]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.lockedForm &&
      !(form.key === 'participants_assignment' && _vm.logged.access < 3) &&
      !(!_vm.$route.params.historyid && _vm.user.status === 0 && (['profile', 'contact'].includes(form.role))) &&
      !(_vm.$route.params.historyid && form.key === 'participants_assignment' && _vm.logged.access < 3)) ? _c('button', {
      staticClass: "btn green mt-ladda-btn ladda-button formSave",
      attrs: {
        "data-style": "expand-left",
        "id": _vm.generateId(form.name) + '_context'
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.submitForm(form)
        }
      }
    }, [_c('span', {
      staticClass: "ladda-label"
    }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), ((_vm.$route.params.historyid != null && !_vm.lockedForm) && !(_vm.$route.params.historyid && form.key == 'participants_assignment' && _vm.logged.access < 4)) ? _c('router-link', {
      staticClass: "btn default",
      attrs: {
        "to": {
          name: 'Participant Edit',
          params: {
            id: _vm.$route.params.id
          }
        },
        "tag": "button",
        "type": "button"
      }
    }, [_vm._v("\n                  Cancel\n                ")]) : _vm._e(), _vm._v(" "), (_vm.lockedForm && !(form.key == 'participants_assignment' && _vm.logged.access < 3)) ? _c('button', {
      staticClass: "btn green",
      on: {
        "click": function($event) {
          _vm.lockedForm = false
        }
      }
    }, [_vm._v("Modify\n                ")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.id != null) ? _c('router-link', {
      staticClass: "btn green",
      attrs: {
        "to": {
          name: 'Dashboard Participant',
          params: {
            id: _vm.$route.params.id
          }
        },
        "tag": "button",
        "type": "button"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.participantSingularName) + " Dashboard\n                ")]) : _vm._e(), _vm._v(" "), (['Participant Profile', 'Entity Profile'].includes(form.name)) ? _c('a', {
      staticClass: "btn default pull-right",
      on: {
        "click": function($event) {
          return _vm.printPage('/print/form/' + form.forms[0].data_id)
        }
      }
    }, [_vm._v("Print")]) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), (_vm.forms.length !== 0) ? _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.query.activeTab === 'correspondence'
    },
    staticStyle: {
      "padding-top": "5px"
    },
    attrs: {
      "id": "correspondence"
    }
  }, [_c('correspondence', {
    attrs: {
      "user": _vm.logged
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.historyid != null && _vm.logged.access > 2) ? _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.query.activeTab === 'modifyForms'
    },
    staticStyle: {
      "padding-top": "5px"
    },
    attrs: {
      "id": "modifyForms"
    }
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columnsModifyForms,
      "rows": _vm.rowsModifyForms,
      "globalSearch": false,
      "paginate": false
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('a', {
          class: {
            'bold': _vm.isModified(props.row.type)
          },
          on: {
            "click": function($event) {
              return _vm.showModifyForms(props.row.type)
            }
          }
        }, [_vm._v(_vm._s(props.row.name))])]
      }
    }], null, false, 3271867830)
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$route.params.id != null) ? _c('router-link', {
    staticClass: "btn green",
    attrs: {
      "to": {
        name: 'Dashboard Participant',
        params: {
          id: _vm.$route.params.id
        }
      },
      "tag": "button",
      "type": "button"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.participantSingularName) + " Dashboard\n                ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.historyid != null && _vm.logged.access > 2) ? _c('div', {
    staticClass: "tab-pane",
    class: {
      active: _vm.query.activeTab === 'communication-notes'
    },
    attrs: {
      "id": "communication-notes"
    }
  }, [_c('communication-notes', {
    attrs: {
      "participant-id": _vm.$route.params.id,
      "assignment-id": _vm.$route.params.historyid
    }
  })], 1) : _vm._e()], 2)]), _vm._v(" "), (_vm.modifyForms === 'assessment') ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('forms-page', {
    attrs: {
      "type": "assessment_outcomes",
      "sort-by-name": true,
      "history": true,
      "force-read-only": (_vm.logged.access < 4)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.modifyForms === 'activities') ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('forms-page', {
    attrs: {
      "type": "activities_services",
      "sort-by-name": true,
      "history": true,
      "force-read-only": (_vm.logged.access < 4)
    }
  })], 1) : _vm._e()])])])]), _vm._v(" "), (_vm.showAssignmentConfirmationModal) ? _c('confirm-assignment-overwrite-modal', {
    on: {
      "confirm": _vm.confirmAssignmentOverwrite,
      "hidden": function($event) {
        _vm.showAssignmentConfirmationModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showExistingParticipantModal) ? _c('existing-participant-modal', {
    attrs: {
      "user": _vm.logged,
      "columns": _vm.existingParticipantColumns,
      "found-users": _vm.foundUsers
    },
    on: {
      "confirm": function($event) {
        return _vm.submitForm(_vm.forms[1], true)
      },
      "hidden": function($event) {
        _vm.showExistingParticipantModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-list-head list-simple font-white bg-yellow"
  }, [_c('div', {
    staticClass: "list-head-title-container"
  }, [_c('div', {
    staticClass: "list-date"
  }), _vm._v(" "), _c('h5', {
    staticClass: "list-title"
  }, [_vm._v("ASSIGNMENT HISTORY")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-icon-container done"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24671ade","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Participant.vue
// module id = 1584
// module chunks = 1